module.exports = __webpack_public_path__ + "img/happy.f237df05.png";